import React from 'react';
import RefundItemAccordion from '../../../../studentRefundRequest/multiTypeRefund/selectRefundItems/refundItems/components/RefundItemAccordion';
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import { UploadedFile } from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/UploadDocument';
import styles from "../styles.module.scss";
import { refundItemsInfoMap, WITHDRAWAL_REFUND, CONCESSION_REFUND } from '../../../../studentRefundRequest/multiTypeRefund/utils';
import CalculationsCard from '../../../../studentRefundRequest/multiTypeRefund/selectRefundItems/refundItems/components/withdrawalRefundCalculations/CalculationsCard';
import AAccordion from '../../../../../../components/AAccordion/AAccordion';
import ViewConcessionRefundItems from './ViewConcessionRefundItems';
import { FaChevronDown } from "react-icons/fa";
import DLPWithdrwalRefundForm from '../../../../studentRefundRequest/multiTypeRefund/selectRefundItems/refundItems/components/DLPWithdrawalRefund';

const accordionStyles = {
  borderRadius: "16px",
  border: "2px solid #E2E2E2",
  padding: "20px",
}


export const DataCell = ({ label, value, children }) => {
  return (
    <div className="d-flex flex-column">
      <span className="regular-small">{label} :</span>
      <span className="large-semi-bold label-color">
        <span className="d-flex">
          {" "}
          {value || (!children && "-")} {children}
        </span>
      </span>
    </div>
  );
}


const ViewRefundItem = ({
  refundItemDetails,
  withdrawalFeeSummary,
  dlpWithdrawalRefundDetails,
  isDLPCase
}) => {

  const { payableToParent, payableToVendor, parentAttachmentKey, loanAttachmentKey, refundAmount, subOrderType } = refundItemDetails ?? {};

  const labelFieldMapping = [
    { label: 'Refund Reason', field: 'rectificationReason' },
    { label: 'Remarks', field: 'remarks' },
    ...(payableToParent
      ? [
        { label: 'Parent Amount', renderExtra: formattedPrice(payableToParent) },
        { label: 'Parent Attachment', renderExtra: <UploadedFile fileName='Parent Attachment' attachmentKey={parentAttachmentKey} viewOnly /> }
      ]
      : []),
    ...(payableToVendor
      ? [
        { label: 'Third Party Amount', renderExtra: formattedPrice(payableToVendor) },
        { label: 'Loan Attachment', renderExtra: <UploadedFile fileName='Loan Attachment' attachmentKey={loanAttachmentKey} viewOnly /> }
      ]
      : []),
  ]

  return (
    <AAccordion customStyles={accordionStyles} expandIcon={<FaChevronDown />}>
      <div className='d-flex align-items-center'>
        <div className={`large-semi-bold label-color mr-1`}>{refundItemsInfoMap[subOrderType]?.label} •</div>
        <div className={`${styles['amount']}`}>{formattedPrice(refundAmount)}</div>
      </div>

      <div>
    {subOrderType===CONCESSION_REFUND && <ViewConcessionRefundItems refundDetails={refundItemDetails} />}
      <div className={`${styles['three-cols-grid']} my-2`}>
        {labelFieldMapping?.map(el => { 
          const { label, field, renderExtra } = el;
          return (
            <DataCell
              label={label}
              value={refundItemDetails[field]}
              key={field}
            >
              {renderExtra}
            </DataCell>
          )
        })}

        </div>

        {subOrderType === WITHDRAWAL_REFUND && (
          isDLPCase
            ? <DLPWithdrwalRefundForm
              dlpWithdrawalRefundDetails={dlpWithdrawalRefundDetails}
              viewOnly={true} 
            />
            : <CalculationsCard calculatedData={withdrawalFeeSummary} />
        )}
      </div>

    </AAccordion>
  );
}

export default ViewRefundItem;